import Axios from 'axios';
import { useContext, useEffect, useState } from 'react';
import { Col, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import InputControl from 'components/inputs/InputControl';
import InputFarsi from 'components/inputs/InputFarsi';
import InputNumber from 'components/inputs/InputNumber';
import Mobile from 'components/inputs/Mobile';
import Switchrs from 'components/inputs/Switchrs';
import Loader from 'components/layout/Loader';
import DashboardContext from 'Context';
import Mapbox from 'components/map/Mapbox';
import toaster from 'helper/toaster';
/**
 * این کامپوننت برای نمایش ادرس در پروفایل مشتری و ثبت سفارش است
 */
export default function FormAddMoudal({
  show,
  handelClose,
  id,
  idUpdate,
  LodingUpdate,
  handelReload,
  handelLodingUpdate,
  handelclaerid,
  isContractual = false,
  close,
}) {
  const { authentication, urldashboard, handelerrors } =
    useContext(DashboardContext);

  const [lodingForm, setLodingForm] = useState(false);

  const [dataDelete, setDataDelete] = useState('');

  const [formdata, setFormdata] = useState({ isActive: false });

  const [dataUpdate, setDataUpdate] = useState({});

  const [dataDefualtForm, setDataDefualtForm] = useState({});

  const [visualAddress, setVisualAddress] = useState('');
  const [coordinate, setCoordinate] = useState([35.715298, 51.404343]);

  const dataFeching = async () => {
    try {
      const res = await Axios.get(
        `${urldashboard}/address/update/${idUpdate}`,
        {
          headers: {
            Authorization: authentication,
            'content-type': 'application/json; charset=utf-8',
          },
        }
      );
      const data = await res.data.data;
      setDataUpdate(data);
      setFormdata(data);
      setCoordinate([data?.latitude, data?.longitude]);
      setVisualAddress(data?.userAddress);
      const element = document.getElementById('userAddressTextarea');
      if (element) {
        element.textContent = data?.userAddress;
      }
      handelLodingUpdate(false);
    } catch (error) {
      if (error.message === 'Network Error') {
        toast.error('اینترنت قطع است لطفا وضعیت اینترنت را بررسی کنید:(', {
          position: 'bottom-left',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        handelClose();
      } else {
        handelClose();
        toast.error(error.response.data.message, {
          position: 'bottom-left',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }
  };

  const dataDefualt = async () => {
    try {
      const res = await Axios.get(`${urldashboard}/address/create/${id}`, {
        headers: {
          Authorization: authentication,
          'content-type': 'application/json; charset=utf-8',
        },
      });
      const datas = await res.data.data;
      setDataDefualtForm(datas);
      setFormdata({ ...formdata, ...datas });
    } catch (error) {
      handelerrors(error);
      handelClose();
    }
  };

  useEffect(() => {
    if (idUpdate) {
      dataFeching();
    } else {
      dataDefualt();
    }
    return () => {};
  }, [idUpdate]);

  useEffect(() => {
    setFormdata({
      ...formdata,
      latitude: coordinate[0],
      longitude: coordinate[1],
    });
  }, [coordinate, setCoordinate]);

  useEffect(() => {
    setFormdata({ ...formdata, userAddress: visualAddress });
  }, [visualAddress]);

  const handelValue = (name, value) => {
    switch (name) {
      case 'prefixId':
        setFormdata({ ...formdata, prefixId: value, userId: id });
        break;
      case 'firstName':
        setFormdata({ ...formdata, firstName: value });
        break;
      case 'lastName':
        setFormdata({ ...formdata, lastName: value });
        break;
      case 'personPositionId':
        setFormdata({ ...formdata, personPositionId: value });
        break;
      case 'tell':
        setFormdata({ ...formdata, tell: value });
        break;
      case 'cellPhone':
        setFormdata({ ...formdata, cellPhone: value });
        break;
      case 'placeTypeId':
        setFormdata({ ...formdata, placeTypeId: value });
        break;
      case 'districtId':
        setFormdata({ ...formdata, districtId: value });
        break;
      case 'userAddress':
        setFormdata({ ...formdata, userAddress: value });
        break;
      case 'isPrimaryFormAddres':
        setFormdata({ ...formdata, isPrimary: value });
        break;
      case 'isActiveFormAddres':
        setFormdata({ ...formdata, isActive: value });
        break;
      // case 'mapuser':
      //     setFormdata({ ...formdata, latitude: value.lat, longitude: value.lng })
      //     break;
      default:
        break;
    }
  };

  const handelSend = async () => {
    setLodingForm(true);

    try {
      const res = await Axios.post(
        `${urldashboard}/address/create`,
        JSON.stringify(formdata),
        {
          headers: {
            Authorization: authentication,
            'content-type': 'application/json; charset=utf-8',
          },
        }
      );
      const data = await res.data;
      if (isContractual) {
        toaster?.success(data.message);
        close();
      } else {
        handelClose(false);
        setLodingForm(false);
        handelReload();
        toast.success(data.message, {
          position: 'bottom-left',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      if (error.message === 'Network Error') {
        setDataDelete({
          status: 500,
          message: 'اینترنت قطع است لطفا وضعیت اینترنت را بررسی کنید:(',
        });
        setLodingForm(false);
      } else {
        setDataDelete(error.response.data);
        setLodingForm(false);
      }
    }
  };

  const handelUpdataFrom = async () => {
    setLodingForm(true);
    try {
      const res = await Axios.put(
        `${urldashboard}/address/update`,
        JSON.stringify(formdata),
        {
          headers: {
            Authorization: authentication,
            'content-type': 'application/json; charset=utf-8',
          },
        }
      );
      const data = await res.data;
      handelClose(false);
      setLodingForm(false);
      handelReload();
      toast.success(data.message, {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (error) {
      if (error.message === 'Network Error') {
        setDataDelete({
          status: 500,
          message: 'اینترنت قطع است لطفا وضعیت اینترنت را بررسی کنید:(',
        });
        setLodingForm(false);
      } else {
        setDataDelete(error.response.data);
        setLodingForm(false);
      }
    }
  };

  const handelSubmit = (event) => {
    event.preventDefault();
    setLodingForm(true);
    if (!formdata.prefixId) {
      toast.error('لطفا پیشوند را انتخاب کنید', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setLodingForm(false);
    } else if (!formdata.lastName) {
      toast.error('لطفا نام خانوادگی را وارد کنید', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setLodingForm(false);
    } else if (!formdata.personPositionId) {
      toast.error('لطفا سمت را انتخاب کنید', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setLodingForm(false);
    } else if (!formdata.cellPhone) {
      toast.error('لطفا شماره خدمت گیرنده را وارد کنید', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setLodingForm(false);
    } else if (!formdata.placeTypeId) {
      toast.error('لطفا نوع ادرس را وارد کنید', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setLodingForm(false);
    } else if (!formdata.districtId) {
      toast.error('لطفا ناحیه را وارد کنید', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setLodingForm(false);
    } else if (!formdata.userAddress) {
      toast.error('لطفا ادرس را وارد کنید', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setLodingForm(false);
    } else {
      dataUpdate.prefixId ? handelUpdataFrom() : handelSend();
    }
  };
  const handelexit = () => {
    // handelClose()
    setDataDelete('');
    setDataUpdate({});
    setFormdata({ isActive: false });
    handelLodingUpdate(false);
    handelclaerid();
    handelClose(false);
  };

  const onSearch = async (e) => {
    const response = await Axios.get(
      `https://api.parsimap.ir/geocode/forward?key=p1a549c4b0187f4ebdade6f9c441a23ac0d78bf40&search_text=${e}&subdivision=true`
    );

    const stats =
      response?.data?.results?.length > 0
        ? response?.data?.results[0]?.geo_location?.center
        : {};
    if (stats?.lat && stats?.lng) {
      setCoordinate([stats?.lat, stats?.lng]);
    }
  };

  return (
    <div show={show} onHide={handelClose} size={'lg'}>
      <button
        type='button'
        style={{ margin: '1rem 0' }}
        className='btn btn-danger btn-icon-text btn-sm'
        onClick={handelexit}
      >
        لغو{' '}
      </button>
      <div>
        {lodingForm ? (
          'درحال انجام منتظر باشید...'
        ) : dataDelete.hasOwnProperty('status') ? (
          dataDelete.message
        ) : (
          <>
            {LodingUpdate ? (
              <Loader />
            ) : (
              <Form>
                <Form.Row>
                  <Col lg='3' md='3' sm='6' xs='12'>
                    <InputControl
                      url='/prefix/dropdown'
                      label='پیشوند'
                      name='prefixId'
                      handelValue={handelValue}
                      defaultValue={dataUpdate.prefixId}
                    />
                  </Col>
                  <Col lg='3' md='3' sm='6' xs='12'>
                    <InputFarsi
                      name='firstName'
                      label='نام'
                      handelValue={handelValue}
                      defaultValue={
                        dataDefualtForm.firstName
                          ? dataDefualtForm.firstName
                          : dataUpdate.firstName
                      }
                    />
                  </Col>
                  <Col lg='3' md='3' sm='6' xs='12'>
                    <InputFarsi
                      name='lastName'
                      label='نام خانوادگی'
                      handelValue={handelValue}
                      defaultValue={
                        dataDefualtForm.lastName
                          ? dataDefualtForm.lastName
                          : dataUpdate.lastName
                      }
                    />
                  </Col>

                  <Col lg='3' md='3' sm='6' xs='12'>
                    <InputControl
                      url='/personposition/dropdown'
                      name='personPositionId'
                      label='سمت'
                      handelValue={handelValue}
                      defaultValue={dataUpdate.personPositionId}
                    />
                  </Col>
                  <Col lg='3' md='3' sm='6' xs='12'>
                    <InputNumber
                      label='شماره ثابت'
                      maxLength='8'
                      name='tell'
                      handelValue={handelValue}
                      defaultValue={
                        dataDefualtForm.tell
                          ? dataDefualtForm.tell
                          : dataUpdate.tell
                      }
                    />
                  </Col>
                  <Col lg='3' md='3' sm='6' xs='12'>
                    <Mobile
                      label='شماره خدمت گیرنده'
                      name='cellPhone'
                      handelValue={handelValue}
                      defaultValue={
                        dataDefualtForm.cellPhone
                          ? dataDefualtForm.cellPhone
                          : dataUpdate.cellPhone
                      }
                    />
                  </Col>

                  <Col lg='3' md='3' sm='6' xs='12'>
                    <InputControl
                      url='/placetype/dropdown'
                      label='نوع ادرس'
                      name='placeTypeId'
                      handelValue={handelValue}
                      defaultValue={dataUpdate.placeTypeId}
                    />
                  </Col>
                  <Col lg='3' md='3' sm='6' xs='12'>
                    <InputControl
                      url='/district/dropdown'
                      label='ناحیه'
                      name='districtId'
                      handelValue={handelValue}
                      defaultValue={dataUpdate.districtId}
                    />
                  </Col>
                </Form.Row>
                <Form.Row>
                  <Col className='mb-3'>
                    <Mapbox
                      isContractual
                      coordinate={coordinate}
                      setCoordinate={setCoordinate}
                      setAddress={(value) => {
                        setVisualAddress(value);
                        const element = document.getElementById(
                          'userAddressTextarea'
                        );
                        if (element) {
                          element.textContent = value;
                        }
                      }}
                    />
                  </Col>
                </Form.Row>
                <Form.Row>
                  <Col>
                    <div className='form-group'>
                      <label for='userAddressTextarea'>آدرس</label>
                      <textarea
                        className='form-control'
                        id='userAddressTextarea'
                        rows='6'
                        value={formdata?.userAddress || ''}
                        onChange={(e) =>
                          handelValue('userAddress', e.target.value)
                        }
                      ></textarea>
                    </div>
                  </Col>
                </Form.Row>
                <Form.Row>
                  <Switchrs
                    name='isPrimaryFormAddres'
                    label='آدرس اصلی'
                    handelValue={handelValue}
                    checke={formdata.isPrimary}
                  />
                  <Switchrs
                    name='isActiveFormAddres'
                    label='آیا فعال باشد؟'
                    handelValue={handelValue}
                    checke={formdata.isActive}
                  />
                </Form.Row>
              </Form>
            )}
          </>
        )}
      </div>
      <div>
        {/* <Button variant="danger" disabled={lodingForm}
                    onClick={handelexit}> لغو</Button> */}

        <button
          type='submit'
          className='btn btn-success mr-auto mt-3'
          onClick={handelSubmit}
          disabled={lodingForm}
        >
          {lodingForm ? (
            <i className='fa fa-spinner fa-pulse fa-fw'></i>
          ) : dataUpdate.prefixId ? (
            'ثبت ویرایش'
          ) : (
            'ثبت'
          )}
        </button>
      </div>
    </div>
  );
}
